import socialSecurityCard from './socialSecurityCard/socialSecurityCard';
import socialSecurityHeaderEmployee from './socialSecurityHeaderEmployee/socialSecurityHeaderEmployee';
import socialSecuritySearch from './socialSecuritySearch/socialSecuritySearch';
import socialSecurityModal from './socialSecurityModal/socialSecurityModal';

let socialSecurityComponents = angular.module('social-security.components', [
  socialSecurityCard,
  socialSecurityHeaderEmployee,
  socialSecuritySearch,
  socialSecurityModal,
])
  .name;

export default socialSecurityComponents;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/social-security.components.js